const PRODUCT_CAPTAINS_CLUB = 'Captains Club';
const PRODUCT_SUPERPORTS_LISTING = 'Superports Listing';

export { PRODUCT_CAPTAINS_CLUB, PRODUCT_SUPERPORTS_LISTING };
